import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-multiple-user',
  templateUrl: './search-multiple-user.component.html',
  styleUrls: ['./search-multiple-user.component.scss']
})
export class SearchMultipleUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
